import * as React from 'react'
import classNames from 'classnames'
import type { SupportedLanguage } from '../../../shared/i18n/i18n.no-deps'
import i18next from 'i18next'
import { ElementValidation } from './ElementValidation'
import { ElementOptionsIcon } from './ElementOptionsIcon'

interface Props {
    required: boolean
    label: string
    validationMessages: string[]
    hasBeenEdited?: boolean
    language?: SupportedLanguage
    secondaryLabel?: string
    inline?: boolean
    error?: boolean
    id?: string
    onClick?: () => void
    openOptions?: () => void
}

export function ElementLabel(props: Props) {
    const inline = props.inline || false
    const error = props.error || false

    if (!props.label && !props.openOptions) {
        // Display validation messages if there is no label, no openOptions, but validation messages are present
        if (props.validationMessages.length > 0) {
            return (
                <div onClick={props.onClick} className={classNames('AppCore__flow__ExecutionLabel', { inline })}>
                    <div className="AppCore__flow__ExecutionLabel__labels">
                        <ElementValidation validationMessages={props.validationMessages} />
                    </div>
                </div>
            )
        }
        return null
    }

    return (
        (props.label || props.openOptions) && (
            <div onClick={props.onClick} className={classNames('AppCore__flow__ExecutionLabel', { inline })}>
                {props.required && (
                    <div className="AppCore__flow__ExecutionLabel__icon">
                        <zaptic-icon icon-name="asterisk" />
                    </div>
                )}
                <div className="AppCore__flow__ExecutionLabel__labels">
                    <div className="AppCore__flow__ExecutionLabel__firstLabel-wrapper">
                        <label
                            htmlFor={props.id}
                            className={classNames('AppCore__flow__ExecutionLabel__label', { error })}
                        >
                            {props.label}
                        </label>
                        {props.hasBeenEdited && props.language && (
                            <div className="AppCore__flow__ExecutionLabel__label-answer-edit">
                                {`(${i18next.t('appcore:common.edited')})`}
                            </div>
                        )}
                    </div>
                    {props.secondaryLabel && (
                        <div className="AppCore__flow__ExecutionLabel__secondaryLabel">{props.secondaryLabel}</div>
                    )}
                    <ElementValidation validationMessages={props.validationMessages} />
                </div>
                {props.openOptions && <ElementOptionsIcon openOptions={props.openOptions} />}
            </div>
        )
    )
}
